
  (function () {
    var minStars = 3;

    function getStarsFromAria(el) {
      if (!el) return null;
      var aria = el.getAttribute('aria-label') || '';
      var match = aria.match(/^(\d+)\s+out\s+of\s+5\s+stars/i);
      return match ? parseInt(match[1], 10) : null;
    }

    function filterJudgeMeReviews(root) {
      var scope = root || document;
      var items = scope.querySelectorAll('.jm-review-item');

      items.forEach(function (item) {
        var starsEl = item.querySelector('.jm-star-rating[aria-label]');
        var stars = getStarsFromAria(starsEl);

        if (typeof stars === 'number' && stars < minStars) {
          item.style.display = 'none';
        }
      });
    }

    filterJudgeMeReviews(document);

    var container = document.querySelector('.jdgm-widget, .jm-review-widget, body');
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          filterJudgeMeReviews(container);
          break;
        }
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  })();
